import Skeleton from '../Skeleton';
import styles from './style.module.scss';

interface Props {
    /** Number of body rows to fake. */
    rows?: number;
    /** Number of columns of the desktop table. */
    columns?: number;
    /** Renders the "Select all" band that sits above the column headers. */
    selectable?: boolean;
    /** Renders the grouped header band (e.g. "Question levels" / "Test cases"). */
    grouped?: boolean;
    className?: string;
};

const range = (length: number) => Array.from({ length }, (_, index) => index);

function TableSkeleton(props: Props) {
    const {
        rows = 6,
        columns = 6,
        grouped = false,
        selectable = false,
        className,
    } = props;

    const gridStyle = { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` };

    return (
        <div
            role='status'
            aria-busy='true'
            aria-label='Loading applicants list'
            className={`${styles.wrapper}${className ? ` ${className}` : ''}`}
        >
            <div className={styles.table}>
                {selectable && <div className={styles.band}>
                    <Skeleton width={130} height={16} />
                </div>}

                {grouped && <div className={styles.group} style={gridStyle}>
                    {range(columns).map(column => <Skeleton key={column} height={16} radius={4} />)}
                </div>}

                <div className={styles.head} style={gridStyle}>
                    {range(columns).map(column => <Skeleton key={column} height={14} width='70%' />)}
                </div>

                {range(rows).map(row => <div key={row} className={styles.row} style={gridStyle}>
                    {range(columns).map(column => <Skeleton key={column} height={12} width={column === 0 ? '80%' : '55%'} />)}
                </div>)}
            </div>

            <div className={styles.mobile}>
                {range(rows).map(row => <div key={row} className={styles.card}>
                    <Skeleton width='55%' height={14} />
                    <Skeleton width={16} height={16} radius={4} />
                </div>)}
            </div>
        </div>
    );
};

export default TableSkeleton;
